<template>
  <mu-card id="profileHeader" :class="{ 'has-coverphoto' : profile.cover_photo !== '' }"
           class="profile-header innerProfile"
           v-bind:style="{ 'background-image': 'url(' + profile.cover_photo + ')' }">
    <mu-card-text class="profile-header-content">
      <mu-flexbox align="bottom" justify="bottom">
        <mu-flexbox-item align="bottom">
          <mu-row gutter class="padRow">
            <mu-col width="100" desktop="25" tablet="100" align="center">

            </mu-col>
            <mu-col width="100" desktop="75" tablet="100" align="left" class="profile-text desktop">
              <h1 v-text="profile.display_name"></h1>
              <div class="badges">
                <user-badge v-if="profile.is_admin" type="support"/>
                <user-badge v-if="profile.progress.percentage === 100 && !isHcpView" type="finished-program" />
                <user-badge v-if="profile.champion" type="champion"/>
                <user-badge v-if="isHcpView && isHcpVerified" type="hcp-verified" />
              </div>
              <p class="country" v-if="showPrivacyInfo || profile.country !== null">
                <country-badge :alpha2="profile.location.alpha2" :tooltip="profile.country" />
                <span v-text="profile.country"></span>
              </p>
            </mu-col>
            <mu-col width="100" desktop="75" tablet="70" align="center" class="profile-text mobile">
              <mu-avatar class="relativeAvatar" :size="120" :src="profile.profile_image"></mu-avatar>
              <h1 v-text="profile.display_name"></h1>
              <div class="badges">
                <user-badge v-if="profile.is_admin" type="support"/>
                <user-badge v-if="profile.progress.percentage === 100 && !isHcpView" type="finished-program" />
                <user-badge v-if="profile.champion" type="champion"/>
                <user-badge v-if="isHcpView && isHcpVerified" type="hcp-verified" />
              </div>
            </mu-col>
          </mu-row>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-text>
  </mu-card>
</template>
<script>

  import ProfileApi from '../../../api/Profile'
  import UserBadge from "../../UserBadge/UserBadge";
  import ProfileMixin from "../../../mixins/ProfileMixin";
  import HcpMixin from '../../../mixins/HCPMixin'
  import CountryBadge from "../../CountryBadge/CountryBadge.vue";

  export default {
    components: {
      CountryBadge,
      UserBadge},
    name: 'profile-header',
    mixins: [
      ProfileMixin,
      HcpMixin
    ],
    props: {
      profile: {
        type: Object
      }
    },
    data() {
      return {
        loading: true,
      }
    },
    methods: {
      follow() {
        let self = this;
        ProfileApi.follow({follow_id: self.profile.user_id}).then((response) => {
          let callback = response.data;
          if (callback.complete) {
            if (callback.isFollowing === true) {
              self.profile.auth_user_following = true;
              self.profile.followers += 1;
            } else {
              self.profile.auth_user_following = false;
              self.profile.followers -= 1;
            }
          }
        }).catch((error) => {
          self.$toastr.error(error.response.data.message);
        });
      }
    }
  }
</script>
<style scoped lang="less">

  .blue {
    background: #e9e9e9 !important;
    color: #0179d5 !important;
  }
  .col.profile-text.mobile.col-100.tablet-70.desktop-75 {
    width: 100%;
  }

  .profile-header {
    .profile-text a {
      color: white !important;
    }

    .profile-text.desktop {
      display: block;
      margin: -53px 0 0;
    }

    .profile-text.mobile {
      display: none;
    }

    @media (max-width: 992px) {
      .profile-text.desktop {
        display: none;
      }

      .profile-text.mobile {
        display: block;
      }
    }

    .profile-text {
      z-index: 1;
      position: relative;
    }
  }

  [v-cloak] {
    display: none;
  }
  #profileHeader {
    display: flex;
    align-items: flex-end;
    height: 320px;
    padding: 24px 12px;
    color: #FFFFFF;
    background: #333 no-repeat center center / cover;
    overflow: hidden;
    position: relative;
    @media(max-width: 992px) {
      align-items: center;
    }
    &:before {
      width: 100%;
      height: 100%;
      content: '';
      -webkit-backdrop-filter: blur(2.8px);
      backdrop-filter: blur(2.8px);
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000), linear-gradient(#0179d5, #0179d5);
      opacity: 0.6;
      filter: alpha(opacity=60);
      -ms-filter: alpha(opacity=60);
      position: absolute;
      top: 0;
      left: 0;
    }
    &.has-coverphoto {
      &:before {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
      }
    }
    .profile-header-content {
      width: 100%;
      padding: 0;
    }
    .mu-card-text {
      color: #FFFFFF;
    }
    .country {
      margin: 15px 0 0;
      .flag {
        margin: 0 3px 0 0;
      }
    }
    p {
      margin: 0;
      font-size: 17px;
      font-weight: 400;
    }
  }

  .userAvatar {
    background-size: cover;
    height: 146px;
    position: relative;
  }

  .userAvatar .mu-list {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: none !important;
  }

  .userAvatar .mu-item-title {
    color: white !important;
  }

  .userAvatar .mu-item-text {
    color: white !important;
  }


</style>



// WEBPACK FOOTER //
// ProfileHeader.vue?c06bdefa